import { render, staticRenderFns } from "./ComparativoDePrecios.vue?vue&type=template&id=e002c13c&"
import script from "./ComparativoDePrecios.vue?vue&type=script&lang=js&"
export * from "./ComparativoDePrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports